const sizeCountriesDefaultsMapping = {
  DEFAULT: 'IT',
  // Countries using IT as default
  ZA: 'IT',
  CL: 'IT',
  ID: 'IT',
  PH: 'IT',
  KR: 'IT',
  TW: 'IT',
  TH: 'IT',
  TR: 'IT',
  AT: 'IT',
  BG: 'IT',
  HR: 'IT',
  CZ: 'IT',
  DK: 'IT',
  EE: 'IT',
  FI: 'IT',
  GR: 'IT',
  HU: 'IT',
  IT: 'IT',
  LV: 'IT',
  LT: 'IT',
  PL: 'IT',
  PT: 'IT',
  RO: 'IT',
  SK: 'IT',
  SI: 'IT',
  SE: 'IT',
  IL: 'IT',
  CH: 'IT',
  // Countries using US as default
  CA: 'US',
  US: 'US',
  // Countries using UK as default
  HK: 'UK',
  SG: 'UK',
  IE: 'UK',
  AU: 'UK',
  GB: 'UK',
  // Countries using FRA as default
  BE: 'FRA',
  FR: 'FRA',
  LU: 'FRA',
  NL: 'FRA',
  // Countries using JP as default
  JP: 'JP',
  // Countries using EU as default
  DE: 'EU',
  ES: 'EU',
} as Record<string, string>

/** Maps the initial size country value for the specific country passed as arg. If the country is not on the list, uses default value */
const getInitialSizeCountry = (country: string) =>
  sizeCountriesDefaultsMapping[country?.toUpperCase()] ??
  sizeCountriesDefaultsMapping['DEFAULT']

export const useSizeCountry = () => {
  // List of the countries displayed in the select -> [IT, US, UK, FRA, JP, EU]
  const sizeCountries = Array.from(
    new Set(Object.values(sizeCountriesDefaultsMapping))
  )

  const selectedCountryCookie = useCookie('size-selector-selected-country')
  const { country: routeCountryCode } = useRouteHelper()

  // If the cookie has already been selected, uses the cookie value, otherwise calculates the default based on the mapping
  const selectedCountry = ref(
    selectedCountryCookie.value ?? getInitialSizeCountry(routeCountryCode)
  )

  // Update the cookie only when the value of selectedCountry is changed, not on first load
  watch(selectedCountry, selectedCountry => {
    // Filter the selectedCountry to avoid saving to the cookie wrong values
    selectedCountryCookie.value = sizeCountries.includes(selectedCountry)
      ? selectedCountry
      : selectedCountryCookie.value
  })

  return {
    selectedCountry,
    sizeCountries,
  }
}
